import React from 'react';
import PropTypes from 'prop-types';
import { OrderItemPropType } from '../../prop-types/order-item';
import ItemDisplay from '../../components/item-display';
import ItemQuantityInShipments from '../../components/item-quantity-in-shipments';

import style from './order-items.module.less';

const ReadOnlyItemQuantity = ({ orderItem, showQuantities = false }) => {
  const { quantityOrdered, quantityPlanned } = orderItem;
  if (!showQuantities || quantityPlanned === 0) {
    return null;
  }
  return <ItemQuantityInShipments className={style['item-quantity']} quantityDone={quantityPlanned} totalQuantity={quantityOrdered} />;
};

ReadOnlyItemQuantity.propTypes = {
  orderItem: OrderItemPropType.isRequired,
  showQuantities: PropTypes.bool.isRequired,
};

const ReadOnlyItem = (props) => {
  const { orderItem, onItemHeaderClicked } = props;
  return (
    <div className={style['read-only-item']}>
      <ItemDisplay className={style['item-display']} item={orderItem} onNameClicked={() => onItemHeaderClicked(orderItem)} />
      <ReadOnlyItemQuantity {...props} />
    </div>
  );
};

ReadOnlyItem.propTypes = {
  orderItem: OrderItemPropType.isRequired,
  onItemHeaderClicked: PropTypes.func.isRequired,
  showQuantities: PropTypes.bool,
};

export default ReadOnlyItem;
